<div class="container-box shadow-none p-3">
  <form [formGroup]="form">
    <div class="row">
      <ng-container formGroupName="physical_address">
        <div class="col-md-12">
          <mat-form-field2>
            <input
              type="text"
              matInput
              formControlName="address_line"
              placeholder="Address"
              i18n-placeholder
              appGooglePlaces
              (onAddressChange)="onPlaceChange($event)"
              autocomplete="address-1"
              required
            />
            <mat-error
              *ngIf="
                physicalAddressForm.get('address_line').touched &&
                physicalAddressForm.get('address_line').hasError('required')
              "
            >
              <ng-container i18n>Address is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2>
            <input type="text" matInput formControlName="city_name" placeholder="City" i18n-placeholder required />
            <mat-error
              *ngIf="
                physicalAddressForm.get('city_name').touched &&
                physicalAddressForm.get('city_name').hasError('required')
              "
            >
              <ng-container i18n>City is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <app-country-select
            placeholder="Country"
            [codeCtrl]="physicalAddressForm.get('country_code')"
          ></app-country-select>
        </div>
        <div class="col-md-6">
          <mat-form-field2>
            <input
              type="text"
              matInput
              formControlName="postal_code"
              placeholder="Postal Code"
              i18n-placeholder
              required
            />
            <mat-error
              *ngIf="
                physicalAddressForm.get('postal_code').touched &&
                physicalAddressForm.get('postal_code').hasError('required')
              "
            >
              <ng-container i18n>Postal Code is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-checkbox
            formControlName="display_address"
            matTooltip="Check to display your property address on Booking.com"
            i18n-matTooltip
            style="margin-top: 2.25rem"
            >Display Address</mat-checkbox
          >
        </div>
      </ng-container>
      <div class="col-md-12">
        <app-map-control [formControl]="positionControl" [zoom]="14" height="300px"></app-map-control>
      </div>
    </div>
  </form>
</div>
<div class="mt-3 d-flex align-items-center justify-content-between">
  <button class="btn btn-outline-light" (click)="prev.emit()">
    <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
    <ng-container i18n>Previous</ng-container>
  </button>
  <button class="btn btn-secondary-info" [disabled]="isLoading" (click)="onSave(form)">
    <ng-container i18n>Next</ng-container>
    <i class="cs-icon cs-icon-arrow-right-long text-xxs" *ngIf="!isLoading"></i>
    <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
  </button>
</div>
